import { ITemplate } from '@/store/modules/template/templateTypes'
import { InvoiceEntityId } from '@/general/entityIds'

export interface IFacturaEDialogModel {
  templateEntityTypeId: number,
  step: number,
  selectedTemplate: ITemplate | null
  invoiceId: number
  invoiceDescription: string
  documentId: number
  documentContent: string | null
  validatorErrorList: IFacturaEValidatorError[]
}

export interface IFacturaEValidatorError {
  code: string,
  message: string
}

export const facturaEDialogModel: IFacturaEDialogModel = {
  templateEntityTypeId: InvoiceEntityId.CUSTOMER_INVOICES,
  step: 0,
  selectedTemplate: null,
  invoiceId: 0,
  invoiceDescription: '',
  documentId: 0,
  documentContent: null,
  validatorErrorList: []
}
